import { Divider } from "@/components/ui/atoms/Divider";
import { Typography } from "@/components/ui/atoms/Typography";

interface DateSeparatorProps {
  label: string;
}

export function DateSeparator({ label }: DateSeparatorProps) {
  return (
    <div className="flex items-center gap-2 py-1">
      <Divider className="min-h-0 flex-1 border-t border-dark-invirtus-soft" />
      <Typography variant="body-xs" color="muted" as="span" weight="semibold" className="shrink-0 px-2 py-0.5">
        {label}
      </Typography>
      <Divider className="min-h-0 flex-1 border-t border-dark-invirtus-soft" />
    </div>
  );
}
